import { HttpService } from "../../modules/shared/services/http.service";
import { Payment, PaymentCreateDto } from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

export const createPayment = async (data: PaymentCreateDto): Promise<Payment> => {
	const response = await HttpService.post("api/v1/payments", data, headers, true);
	return response;
};

export const updatePayment = async (id: string, data: Partial<PaymentCreateDto>): Promise<Payment> => {
	const response = await HttpService.patch(`api/v1/payments/${id}`, data, headers, true);
	return response;
};

export const getPaymentById = async (id: string): Promise<Payment> => {
	const response = await HttpService.get(`api/v1/payments/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getPayments = async (query?: Record<string, string | number | boolean>): Promise<{ data: Payment[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/payments${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deletePayment = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/payments/${id}`, { "x-custom-lang": "en" }, true);
};

export const getPaymentsByMilestones = async (milestoneIds: string[]): Promise<{ data: Payment[]; totalCount?: number }> => {
	const milestoneIdsParam = milestoneIds.join(",");
	const response = await HttpService.get(`api/v1/payments/by-milestones?milestoneIds=${encodeURIComponent(milestoneIdsParam)}`, true, { "x-custom-lang": "en" });
	return response;
};
